/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import { Button } from '@scuf/common';
import ChartWidget from '../../../shared/Chart/ChartWidget';
import { graphEnergy } from '../../../shared/Utils/Utils';
import { ApiContext } from '../../../../context/ApiContext';
import {
  IAny,
  IConvertDataForUtilityTrendChart,
  IUtilityCostData
} from '../../IEnergyManagementProps';
interface IUtilityCostComponentProps {
  data: IUtilityCostData;
}

export const actualWithColor = (graphData: {
  actual: IAny;
  previousPeriod: IAny;
  YearIndex?: string[];
  MonthIndex?: string[];
  IsCompleted?: boolean[];
  PeriodUpto?: number[];
  noDataActual?: boolean;
  noDataPrevious?: boolean;
}) => {
  const addColorInActual = graphData.actual.map(
    (val: number, index: string | number) => {
      if (graphData.previousPeriod[index] >= val) {
        return { y: val, color: '#1272B2' };
      } else {
        return { y: val, color: '#F15A4F' };
      }
    }
  );
  graphData['actual'] = addColorInActual as IAny;
  return graphData;
};

export const UtilityLineGraphComponent = (
  props: IUtilityCostComponentProps
) => {
  const [t, lng] = useTranslation();
  const d = descriptors.energyManagement;
  const { data } = props;

  const apiContext = useContext(ApiContext);
  const { graphType, hideHeader } = apiContext;
  const { utilityCostCurrency, monthwiseAggregations } = data;

  const graphData = graphEnergy(
    (monthwiseAggregations as unknown) as IConvertDataForUtilityTrendChart[],
    undefined,
    lng
  );

  const actualColorUpdateIngraphData = actualWithColor(graphData);
  return (
    <div className="kpi-card-flex-container">
      <div className="kpi-card-monthwise-container">
        <ChartWidget
          graphData={actualColorUpdateIngraphData as IAny}
          unit={utilityCostCurrency!}
          axisUnitType="currency"
          height="118px"
          legendBaseline={true}
          graphType={graphType === 'lineGraph' ? 'lineGraph' : ''}
          hideHeader={hideHeader}
        />
      </div>
    </div>
  );
};
export default UtilityLineGraphComponent;
